import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const heartHealthFeaturesGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#6C5554',
    id: 'brown-1',
    position: [10, 5],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#81685A',
    id: 'brown-2',
    position: [90, 40],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#675653',
    id: 'brown-3',
    position: [5, 80],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#816558',
    id: 'brown-4',
    position: [90, 70],
    opacity: 0.7,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#7A5150',
    id: 'red-1',
    position: [60, 99],
    opacity: 0.7,
    size: 30,
  },
];

export default heartHealthFeaturesGradients;
